module.exports = __webpack_public_path__ + "static/media/location.6c34ea68.svg";